import NL from "./nl.json";
import FR from "./fr.json";

export const LANGUAGE = import.meta.env.VITE_LANGUAGE || "NL";

const LOCALES = {
  NL,
  FR,
};

export default function translate(key) {
  return LOCALES[LANGUAGE.toUpperCase()][key] || key;
}
